import { capitalize } from 'Data/format.js'

function keyValues(obj, separator = ', ') {
  let keys = obj.displayValues || Object.keys(obj)

  let getValue = (path, source) => {
    let parts = path.split('.')
    let value = source
    for (let i = 0; i < parts.length; i++) {
      if (value == null) return undefined
      value = value[parts[i]]
    }
    return value
  }

  return keys.map(key => getValue(key, obj)).join(separator)
}

// just to be a bit careful if we alllow them add the abitrary answer payload
function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function questionsAndAnswers(answers, questions) {
  return answers
    ?.map(item => {
      // loose check to cater to boolean false
      if (
        item.answer === null ||
        item.answer === undefined ||
        item.isInformationOnly
      )
        return false

      let maybeExternal = Object.values(questions).find(
        question => question.id === item?.id
      )

      let prompt =
        maybeExternal?.prompt || questions[item?.id]?.prompt || item?.question

      if (!prompt) return false

      return {
        question: escapeHtml(prompt),
        answer: capitalize(
          escapeHtml(
            Array.isArray(item?.answer)
              ? item?.answer.map(keyValues).join(', ')
              : typeof item?.answer === 'object'
              ? keyValues(item?.answer)
              : item?.answer
          )
        ),
      }
    })
    .filter(Boolean)
}
